export const METRIC_INFO = {
  "NUMBER_OF_SESSIONS": "Total number of chat sessions started by users.A new session starts after 12 minutes of inactivity.",
  "TOTAL_INTERACTIONS": "Total number of conversations across all sessions.",
  "CHATS_HANDLED": "Total number of chats handled by the bot.",
  "VOID_SESSIONS": "Number of sessions where users greeted the bot or left without responding.",
  "ABANDONED_INTERACTIONS": "Number of sessions where the user left before receiving help.",
  "INTERACTIONS_RESOLVED": "Number of conversations successfully completed.",
  "SELF_SERVICE_RATE": "Percentage of sessions handled fully by the bot without agent involvement.",
  "AGENT_TRANSFERS": "Total number of times the chat was transferred to a live agent.",
  "BOUNCE_RATE": "Percentage of sessions where users left without completing the interaction.",
  "UNIQUE_USERS": "Total number of unique users who used the bot, identified by unique user ID (email).",
  "Adoption_Rate": "How often users are using the bot compared to total users.",
  "RETURNING_USERS": "Distinct number of users who interacted with the bot more than once.",
  "CURRENT_USER_BASE": "Number of users who have access to AskIT.",
  "USAGE_RATE": "Percentage of unique users who used AskIT out of the total user base.",
  "ADOPTION_RATE": "Frequency of bot usage compared to the total number of users.",
  "INCIDENTS_CREATED": "Total number of incidents created by users through the bot and logged in ServiceNow with an INC number.",
  "INCIDENT_STATUS_CHECK": "Number of times users checked the status of their incidents.",
  "INCIDENT_UPDATE": "Number of incidents updated by users through AskIT.",
  "RESOLVED_INCIDENTS": "Number of incidents resolved by users through AskIT.",
  "USER_RESOLVED_INCIDENTS": "Total number of incidents resolved or closed by users using the bot.",
  "REOPENED_INCIDENTS": "Number of incidents reopened by users through AskIT.",
  "REQUEST_STATUS_CHECK": "Number of times users checked the status of their service requests.",
  "SERVICE_REQUEST_UPDATE": "Number of service requests updated by users through AskIT.",
  "KB_QUERIES_ANSWERED": "Number of knowledge base questions successfully answered by the bot.",
  "KB_QUERIES_UNANSWERED": "Number of knowledge base questions the bot could not answer.",
  "KB_EFFICIENCY": "Percentage of knowledge base questions answered successfully.",
  "KB_ACCURACY": "Accuracy of the bot’s responses derived from the knowledge base.",
  "ASKIT_ACCURACY": "Overall accuracy of AskIT in responding to user questions.",
  "POSITIVE_FEEDBACK": "Total number of positive feedback responses received.",
  "NEGATIVE_FEEDBACK": "Total number of negative feedback responses received.",
  "CSAT": "Percentage of users who provided positive feedback.",
  "EVALUATION_RATE": "Percentage of sessions where users provided feedback.",
  "PINNED_USER_COUNT": "Number of users using AskIT",
  "APPROVAL_St": "Approval status check by the user",
  "ACR_St": "ACR or SR status check by the user",
  "CH_St": "Change Request(CHG/CG) status check by the user",
  "approved": "Number of requests approved by the approver for users",
  "rejected": "Number of requests rejected by the approver for users",
  "ticketAvoidance": "Issues resolved through KM without ticket or agent support.",
  "nonTicketAvoidance": "Issues requiring ticket or agent support after KM interaction.",
  "directEscalation": "Issues directly escalated without KM usage.",
  "userAbandoned": "Users who left the chat before issue resolution.",
  "directTicketCount": "Tickets created directly without KM interaction.",
  "fallbackTicketCount": "Tickets created after KM could not resolve the issue.",
  "directLiveAgentCount": "Live agent transfers without KM interaction.",
  "fallbackLiveAgentCount": "Live agent transfers after KM assistance."
}
